if (!customElements.get('category-selector')) {
  class CategorySelector extends HTMLElement {
    constructor() {
      super();
      window.addEventListener('DOMContentLoaded', () => this.addEvents())
    }
 
    SELECTORS = {
      selector: ".category-filter-link__selector",
      selectorListsMulti: ".category-filter-link__selector-list--multiple",
      activeIndicator: ".category-filter-link__selector-list-item--active",
      selectedCollection: ".category-filter-link__selected-collection",
      anchorElement: ".category-filter-link__anchor"
    }

    addEvents() {
      const selectorListsMulti = this.querySelectorAll(this.SELECTORS.selectorListsMulti);
      const selectors = this.querySelectorAll(this.SELECTORS.selector);

      if(!selectors || !selectorListsMulti) return

      selectors.forEach((select) => {
        select.addEventListener('click', () => this.toggleSelector(select))
        select.addEventListener('keydown', (e) => {
          if(e.key === "Enter") this.toggleSelector(select)
        })
      })

      selectorListsMulti.forEach((list) => {
        list.addEventListener('click', (e) => this.handleSelectionMulti(e.target, list))
        list.addEventListener('keydown', (e) => {
          if(e.key === "Enter") this.handleSelectionMulti(e.target, list)
        })
        list.addEventListener('mouseleave', () => this.toggleSelector(list.parentElement.querySelector(this.SELECTORS.selector)))
      })
    }

    handleSelectionMulti(clickTarget, list) {
      const activeIndicator = this.SELECTORS.activeIndicator.replace(".", "");
      const listElement = clickTarget.nodeName === "LI" ? clickTarget : clickTarget.closest("li")
      const listTitle = list.parentElement.querySelector(`${this.SELECTORS.selector} span`)
      const actualInput = listElement.querySelector('input');

      if(listElement.classList.contains(activeIndicator)) {
        listElement.classList.remove(activeIndicator);
        actualInput.checked = false
      } else {
        listElement.classList.add(activeIndicator);
        actualInput.checked = true
      }

      const namesArray = []
      const actualSelectedInputs = list.querySelectorAll('input:checked');
      actualSelectedInputs.forEach((input) => {
        namesArray.push(input.getAttribute('name').replace("check-", ""))
      })

      listTitle.textContent = namesArray.length === 0 ? list.dataset.default : namesArray.join(", ")
      
      this.generateNewUrl();
    }

    generateNewUrl() {
      const selectedParams = this.querySelectorAll(`${this.SELECTORS.selectorListsMulti} input:checked`);
      const selectedCategoryUrl = this.querySelector(this.SELECTORS.selectedCollection)?.value;
      const anchorElement = this.querySelector(this.SELECTORS.anchorElement)

      if (!selectedCategoryUrl || !anchorElement) return

      let newUrl = selectedCategoryUrl

      if(selectedParams.length) {
        selectedParams.forEach((param, index) => {
          newUrl = index == 0 ? `${newUrl}?${param.value}` : `${newUrl}&${param.value}`
        })
      }

      // clear client mistakes
      newUrl.replaceAll("??", "?").replaceAll("&&", "&")
      anchorElement.href = newUrl
    }

    toggleSelector(select) {
      if(!select) return
      const selectorHolder = select.parentElement
      const listItems = selectorHolder.querySelectorAll(`li`)
      if(selectorHolder.classList.contains('open')) {
        selectorHolder.classList.remove('open')
        listItems.forEach(cat => cat.tabIndex = -1)
      } else {
        const openedSelects = this.querySelectorAll(`.open`)
        openedSelects.forEach((s) => s.classList.remove('open'))
        selectorHolder.classList.add('open')
        listItems.forEach((cat, index) => {
          cat.tabIndex = 0;
          if(index === 0) cat.focus();
        })
      }
    }
  }

  customElements.define('category-selector', CategorySelector);
}
